import { injectable, inject } from 'inversify';
import { ObjectCompletionHandlerInterface } from './object-completion-handler-interface';
import { SectionInteraction, SectionCompletion } from '@/app/statistics/section/section-progress';
import { SectionProgressUtils, SectionProgressUtilsSymbol } from '@/app/statistics/section/section-progress-utils';
import { createInteractionId } from '@/app/statistics/section/section-interaction-utils';

export const QUESTION_TYPE: string = 'question';

@injectable()
export class QuestionsCompletionHandler implements ObjectCompletionHandlerInterface {

  @inject(SectionProgressUtilsSymbol)
  private sectionProgressUtils: SectionProgressUtils;

  public calculateDefaultInteractions($container: any|null): SectionInteraction[] {
    let interactions: SectionInteraction[] = [];
    $('.question.component', $container).each((index: number, element: any) => {
      const $element: any = $(element);
      const id: string = createInteractionId(QUESTION_TYPE, $element.attr('data-question-id'));
      const title: string = $('.question-component', $element).attr('data-title') || 'question-component';

      interactions = [...interactions, {
        id,
        title,
        type: QUESTION_TYPE,
        completed: false,
        items: {}
      }];
    });

    return interactions;
  }

  public setInteraction(completion: SectionCompletion, interaction: any): SectionCompletion {
    if (interaction.type && interaction.type === QUESTION_TYPE) {
      const questionId: string = interaction.id;
      completion = this.sectionProgressUtils.setInteractionItemCompleted(
        completion,
        questionId,
        QUESTION_TYPE,
        null,
        false
      );
    }

    return completion;
  }
}
